<template>
  <v-app>
    <simulator></simulator>
  </v-app>
</template>
<script>
import Simulator from "@/components/Simulator";

export default {
  components: { Simulator },
  data() {
    return {};
  },
  methods: {
    onClose(close) {
      if (close) {
        this.dialog = false;
      }
    },
  },
};
</script>
<style>
.v-application--wrap{
  min-height: auto !important;
  /*max-width: max-content !important;*/
  background: #0BC6D7;
}

.v-card__text {
  padding: 0 14px 10px !important;
}

.buttonText {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
}
</style>
